export const SUPPORTED_LANGUAGE_CODES = ['en', 'it', 'es'];

const LANGUAGE_TO_INTL_LOCALE = {
  en: 'en-US',
  it: 'it-IT',
  es: 'es-ES',
};

export const resolveLanguageCode = (input, fallback = 'en') => {
  const normalizedFallback = SUPPORTED_LANGUAGE_CODES.includes(fallback) ? fallback : 'en';
  if (!input || typeof input !== 'string') {
    return normalizedFallback;
  }
  const normalized = input.trim().toLowerCase();
  if (!normalized) {
    return normalizedFallback;
  }
  const exactMatch = SUPPORTED_LANGUAGE_CODES.find((code) => code === normalized);
  if (exactMatch) {
    return exactMatch;
  }
  const prefixMatch = SUPPORTED_LANGUAGE_CODES.find((code) => normalized.startsWith(`${code}-`) || normalized.startsWith(`${code}_`));
  return prefixMatch || normalizedFallback;
};

export const resolveIntlLocale = (input, fallback = 'en') => {
  const languageCode = resolveLanguageCode(input, fallback);
  return LANGUAGE_TO_INTL_LOCALE[languageCode] || LANGUAGE_TO_INTL_LOCALE.en;
};

export const isEnglishLocale = (input) => resolveLanguageCode(input) === 'en';
